const DocumentType = {
    Vessel: 'vessel',
    Tracker: 'tracker'
};
export default DocumentType;
